import { render } from "./ListCommandesFournisseursPage.vue?vue&type=template&id=5ad38032&ts=true"
import script from "./ListCommandesFournisseursPage.vue?vue&type=script&lang=ts"
export * from "./ListCommandesFournisseursPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__